export function populateFooter(jsonData){

    footerData = jsonData

    var footerHeadingText = jsonData.footer.section_heading.value;

    if(!$(document).find(".preview").hasClass("hidden")){
        $("#footerHeadingText").html(footerHeadingText);    
    }
    else{                            
        $("input#footerHeadingText").val(footerHeadingText);    
    }
    
    socialData = jsonData.footer.data.social_handles;
    
    function getFooter() {
        var member = $('.footer__ico.prototype.hidden').clone().removeClass('prototype hidden');
        member.addClass("footerLink")
        return {
            element: member,
            handle: member.find("a"),
            icon: member.find("a").find("i")
        }
    }

    function populateData(jsonData){
        var count = 0;
        $.each(socialData, function(index, item) {

            if(count< socialData.length){
                var newHandle = getFooter(); 
                if(!$(document).find(".preview").hasClass("hidden")){
                    if(item.link){
                        newHandle.handle.attr("data", item.link);
                        newHandle.handle.attr("id", item.id);
                        newHandle.handle.attr("href", item.link);
                        newHandle.icon.addClass(item.icon)
                        $(".footer__socicobox").append(newHandle.element);
                    }
                }
                else{   
                    newHandle.handle.attr("data", item.link); 
                    newHandle.handle.attr("id", item.id);
                    newHandle.icon.addClass(item.icon)
                    $(".footer__socicobox").append(newHandle.element);                        
                }               

                count++;
            }
        });
    }

    populateData(jsonData);
   
}